export default function formatFieldName(rawName: string) {
  return rawName
    .trim()
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .replace(/^[^a-zA-Z0-9]+/, '')
    .replace(/[^a-zA-Z0-9]+$/, '')
    .toLowerCase()
}
